import Url from 'url'
import _ from 'lodash'
import querystring from 'querystring'
import MemberInfo from './memberinfo'
import APPSETTING from '../../../config/appsetting.js'
import COMMON from './common.js'

var appcontrollers = {
	// 这个是调用页面的方法 apphref://functionController/searchbyimage?param_gcid=fadfa
	APP_FUNC: { ios: 'functionController', android: 'functionActivity', wxapp: 'functionController', wap: 'functionController' },
	// 对应页面: h5
	APP_H5: { ios: 'html5WebViewController', android: 'H5Activity', wxapp: '/pages/webview/webview', wap: 'common/h5' },
	// 对应页面: 登录
	APP_LOGIN: { ios: 'NewLoginController', android: 'LoginActivity', wxapp: '/pages/login-register/login/login', wap: '/common/singon' },
	// 对应页面: 注册
	APP_REGISTER: { ios: 'RegisterController', android: 'RegisterActivity', wxapp: '/pages/login-register/forget/forgetpassword', wap: '/common/singin' },
	// 对应页面: 安全验证
	APP_SAFETY_CHECK: { ios: 'RegisterController', android: 'SafetyCheckActivity', wxapp: '', wap: '/common/safety' },
	// 对应页面: 绑定手机
	APP_BIND_PHONE: { ios: 'RegisterController', android: 'BindPhoneActivity', wxapp: '/pages/login-register/forget/forgetpassword', wap: '/common/bindphone' },
	// 对应页面: 找回登录密码
	APP_FORGET_PASSWORD: { ios: 'RegisterController', android: 'UpdatePasswordActivity', wxapp: '/pages/login-register/register/register', wap: '/common/findpassword' },
	// 对应页面: 找回支付密码
	APP_FORGET_PAY_PASSWORD: { ios: 'RegisterController', android: 'UpdatePayPasswordActivity', wxapp: '/pages/login-register/register/register', wap: '/common/paypassword' },
	// 对应页面: 商家列表
	APP_STORES: { ios: 'VenderListController', android: 'VenderActivity', wxapp: '/pages/vender/vender', wap: '/commodity' },
	// 对应页面：商家APP首页
	APP_STORE_TAB_INDEX:{ ios: 'HomeStoreController', android: 'StoreHomeActivity', wxapp: '', wap: '/' },
	// 对应页面：店铺首页
	APP_STORE_INDEX:{ ios: 'ShopHomeController', android: 'StoreDetailActivity', wxapp: '/pages/store/storeindex', wap: '/common/storehome' },
	// 对应页面：商城分类
	APP_GOODS_CLASS:{ ios: 'GoodsClassViewController', android: 'GoodsClassActivity', wxapp: '/pages/searchGoods/search', wap: '/findgoods' },
	// 对应页面：店铺分类
	APP_STORE_CLASS:{ ios: 'StoreClassController', android: 'StoreClassActivity', wxapp: '/pages/store/category/category', wap: '/common/subclass' },
	// 对应页面：购物车
	APP_CART:{ ios: 'ShoppingCartController', android: 'CartActivity', wxapp: '/pages/cartlists/cartlist', wap: '/shoppingcate' },
	// 对应页面：商品列表
	APP_GOODS_LIST:{ ios: 'GoodsListController', android: 'GoodsListActivity', wxapp: '/pages/goodslist/goodslist', wap: '/common/goodslist' },
	// 对应页面：商品详情
	APP_GOODS_DETAIL:{ ios: 'GoodDetailController', android: 'GoodsDetailActivity', wxapp: '/pages/goodsdetail/goodsdetail', wap: '/common/goodsdetails/goodsdetail' },
	// 对应页面：个人中心
	APP_USER_CENTER:{ ios: 'AccountSettingController', android: 'AccountActivity', wxapp: '/pages/usercenter/accountsetting/accountsetting', wap: '/accountsetting' },
	// 对应页面：个人中心 -> 订单列表
	APP_ORDER_LIST:{ ios: 'OrderListController', android: 'OrderListActivity', wxapp: '/pages/usercenter/orderlist/orderlist', wap: '/common/order' },
	// 对应页面：个人中心 -> 订单详情
	APP_ORDER_DETAIL:{ ios: 'OrderDetailController', android: 'OrderDetailActivity', wxapp: '/pages/usercenter/orderdetail/orderdetail', wap: '/common/orderdetailsdone' },
	// 对应页面：个人中心 -> 退款
	APP_REFUND:{ ios: 'OrderRefundController', android: 'RefundableActivity', wxapp: '/pages/usercenter/orderrefund/orderrefund', wap: '/common/refundmoney' },
	// 对应页面：个人中心 -> 退款记录列表
	APP_REFUND_LIST:{ ios: 'OrderRefundListController', android: 'RefundListActivity', wxapp: '/pages/usercenter/orderrefundlist/orderrefundlist', wap: '/common/refundlist' },
	// 对应页面：个人中心 -> 退款记录详情
	APP_REFUND_DETAIL:{ ios: 'OrderRefundDetailController', android: 'RefundDetailActivity', wxapp: '/pages/usercenter/orderrefunddetail/orderrefunddetail', wap: '/common/refund' },
	// 对应页面：个人中心 -> 地址列表
	APP_ADDRESS_LIST:{ ios: 'AddressListController', android: 'AddressListActivity', wxapp: '/pages/usercenter/addressctrl/addressctrl', wap: '/common/address' },
	// 对应页面：个人中心 -> 地址编辑
	APP_ADDRESS_EDIT:{ ios: 'AddressEditController', android: 'AddressEditActivity', wxapp: '/pages/usercenter/editaddress/editaddress', wap: '/common/changeaddress' },
	// 对应页面：个人中心 -> 收藏商品
	APP_Favorite_GoodsList:{ ios: 'FavoritesController', android: 'FavoriteListActivity', wxapp: '/pages/usercenter/collect/collect', wap: '/common/collection' },
	// 对应页面：个人中心 -> 关注店铺列表
	APP_Favorite_StoreList:{ ios: 'AttentionController', android: 'FavoriteListActivity', wxapp: '/pages/usercenter/attention/attention', wap: '/common/follow' },
	// 对应页面：个人中心 -> 我的优惠券，代金券
	APP_Voucher_List:{ ios: 'CouponController', android: 'CouponListActivity', wxapp: '', wap: '/common/mycoupons' },
	// 对应页面：个人中心 -> 浏览历史
	APP_History_List:{ ios: 'HistoryController', android: 'BrowseListActivity', wxapp: '/pages/usercenter/scan/scan', wap: '/common/footprint' },
	// 对应页面：个人中心 -> 我的评价列表
	APP_Comment_List:{ ios: 'DiscussController', android: 'MyCommentListActivity', wxapp: '/pages/usercenter/discuss/discuss', wap: '/common/myevaluate' },
	// 对应页面：个人中心 -> 我的平台客户咨询列表
	APP_MyConsult_List:{ ios: 'MyConsultController', android: 'MallConsultActivity', wxapp: '/pages/usercenter/consult/consult', wap: '/common/consult' },
	// 对应页面：个人中心 -> 我的红包列表
	APP_Redpack_List:{ ios: 'RedPackController', android: 'RedPacketListActivity', wxapp: '/pages/usercenter/redPack/redPack', wap: '/common/redpacket' },
	// 对应页面：个人中心 -> 消息总列表
	APP_NEWS_ALLList:{ ios: 'AllNewsController', android: 'MessageActivity', wxapp: '/pages/usercenter/allNews/allnews', wap: '/common/mynews' },
	// 对应页面：个人中心 -> 我的账单
	APP_Bill_List:{ ios: 'BillController', android: 'BillActivity', wxapp: '/pages/usercenter/billList/billlist', wap: '/common/balance' },
	// 对应页面：个人中心 -> 充值卡，账户 充值记录
	APP_PdRecharge_List:{ ios: 'PdRechargeController', android: 'RechargeActivity', wxapp: '/pages/usercenter/PdRecharge/PdRecharge', wap: '/common/predeposit' },
	// 对应页面: 麦田代发
	APP_DAIFAI: { ios: 'MaitianAgencyController', android: 'DaiFaActivity', wxapp: '/pages/daifa/agencydaifa/agencydaifa', wap: '' },
	//文章主页
	APP_ATICLE_HOME: { ios: 'ArticlesHomeController', android: 'ArticleHomeActivity', wxapp: '', wap: '/common/articlelist' },
	//文章搜索列表
	APP_ATICLE_LIST: { ios: 'ArticleSearchListController', android: 'ArticleListActivity', wxapp: '', wap: '/common/articlesearch' },
	//文章详情
	APP_ATICLE_DETAIL: { ios: 'ArticleDetailViewController', android: 'ArticleDetailActivity', wxapp: '', wap: '/common/articledetail' },
}

/* 	window.location.href
 *	@hrefpagetype : 跳转到app原生页面信息 (类型hrefPage)，可为空
 *  @shref : h5目标页面
 *  @appParams : app页面所需参数
 */
// function hrefLocation(hrefpagetype, shref, appParams) {
// 	var apppage;
//   	// var isweixin = function(){ var ua = navigator.userAgent.toLowerCase(); return ua.match(/MicroMessenger/i) == "micromessenger" }
//     if ( appversion>3.0 ) {
//       var $url = shref;
//       var strQuert = "";
//       var params = querystring.parse(strQuert);
//       if (params && params.act) {
//         switch (params.act) {
//             case 'goods':
//                 $url = 'http://www.zhaojiafang.com/wap/tmpl/product_detail.html?1=1' + strQuert;
//             break;
//             case 'ads':
//                 $url = 'http://www.zhaojiafang.com/wap/tmpl/ads_list.html';
//             break;
//             case 'store_list':
//                 $url = 'http://www.zhaojiafang.com/wap/shop.html?1=1&' + strQuert;
//             break;
//             case 'search':
//                 $url = 'http://www.zhaojiafang.com/wap/tmpl/product_list.html?1=1' + strQuert;
//             break;
//             case 'show_store':
//                 if (params.op == 'store_article') {
//                   $url = 'http://www.zhaojiafang.com/wap/tmpl/article_show.html?1=1' + strQuert;
//                 }
//                 else if(params.op == 'show_article'){
//                   $url = 'http://www.zhaojiafang.com/wap/tmpl/article_show.html?1=1' + strQuert;
//                 }
//                 else if(params.op == 'goods_all' || params.op == 'goods_all_list'){
//                   $url = 'http://www.zhaojiafang.com/wap/tmpl/product_goods.html?1=1' + strQuert;
//                 }
//                 else {
//                   $url = 'http://www.zhaojiafang.com/wap/tmpl/product_store.html?1=1&store_id=' + params.store_id;
//                 }
//             break;
//         }
//       }

//       var wta = { product_store: 'storeIndex', product_detail: 'goodsDetail', product_list:'goodsList', product_goods:'goodsList' }
//       for(var k in wta){
//         if ( $url && $url.indexOf( k + '.html' ) > -1 ){
//             var wapquery = querystring.parse(strQuert);
//             hrefpagetype = hrefPage[ wta[k] ];

//             if (k == 'product_store') { appParams = { param_storeid: wapquery.store_id } }
//             else if(k == 'product_detail'){ appParams = { param_goodsid: wapquery.goods_id } }
//             else if(k == 'product_goods' || k == 'product_list'){
//                 if (wapquery.gc_id) appParams = { param_gcid: wapquery.gc_id }; //apinfo.query += '&param_stcid=' + wapquery.stc_id;
//                 if (wapquery.stc_id) appParams = { param_stcid: wapquery.stc_id }; //apinfo.query += '&param_stcid=' + wapquery.stc_id;
//                 if (wapquery.store_id) appParams = { param_storeid: wapquery.store_id }; //apinfo.query += '&param_storeid=' + wapquery.store_id;
//                 if (wapquery.keyword) appParams = { param_keyword: encodeURIComponent(wapquery.keyword || wapquery.inkeyword) }; //apinfo.query += '&param_keyword=' + encodeURIComponent(wapquery.keyword || wapquery.inkeyword); 
                
//                 //添加筛选条件
//                 if (wapquery.params_filters) {
//                   appParams.params_filters = wapquery.params_filters
//                 }
//             }
//         }
//       }
//     }

// 	if (sfrom.toLowerCase() === fromWhere.ios) {
// 		apppage = hrefpagetype.ios ? hrefpagetype.ios : hrefpagetype;
//   		var _href = encodeURIComponent("apphref://"+apppage+"/app?zresource=m&"+$.param(appParams));
// 		window.location.href = _href;
// 	}
// 	else {
//   		apppage = hrefpagetype.android ? hrefpagetype.android : hrefpagetype;
// 		if (window.control && apppage) {
// 			window.control.pushpage(apppage , $.param(appParams));
// 		}
//       	else if(shref){ window.location.href = shref; }
// 	}
// }

var HrefRouter = {
	// 格式化参数，加上统一参数
	_mob_toquery : function(urlparams){
		var squery = '';
		if ( _.isString(urlparams)) { 
			squery = urlparams;
		}
	    else if( _.isObject(urlparams)) {
	        _.map(urlparams, function(v,k){
	          squery += '&'+ k +'='+ encodeURIComponent(v);
	        });
	    }
	    squery += squery.indexOf('key')>0 ? '':'&key=' + MemberInfo.getMemberInfo().key;
    	// squery += squery.indexOf('isfrom')>0 ? '':'&isfrom=a';
		return squery;
	},
	// 根据服务器的的href来解析跳转
	_mob_pushRouter : function(ctrl, href, func){
		if (href.length == 0) { return; }

		var _url = Url.parse(href);
		var ourl_params = querystring.parse(_url.query);
		/*	如果过来的URL请求的是本地方法
		 *	请求方式：functionController?zresource=n&params_func=functionTel&params_phone=400-101-1700 */
		if(_url.pathname == 'functionController'){
			switch(ourl_params.params_func){
				case 'functionTel':{
					let tel =ourl_params.params_phone;
					window.location.href = 'tel://' + tel;
					return;
				}
				break;
				default:
					typeof func  == 'function' && func(ourl_params); return;	
				break;
			}
		} else if(ourl_params.phtml5url){
			var _ph5url = ourl_params.phtml5url; delete ourl_params.phtml5url;
			_ph5url += _ph5url.indexOf('?')>0 ? '':'?zresource=m';
			window.location.href = _ph5url + this._mob_toquery(ourl_params);
		} else{
			var okctrl;	//找到了的终端页面对像
			var keysForAppCtrl = Object.keys(appcontrollers);
			// 寻找对应Path，并跳转到指定终端页面
			for (var i = 0; i < _.size(keysForAppCtrl); i++){
				var _k = keysForAppCtrl[i];
				var appctrl = appcontrollers[_k];
				if (appctrl.wap == _url.pathname) {
					okctrl = appctrl;
					break;
				}
			}
			if (!okctrl) {
				// 如果没有找到okctrl，被视为本地跳转，这时候要嫁接到APP上去 
				okctrl = appcontrollers.APP_H5;
				ourl_params.phtml5url = (_url.host || window.location.origin)+_url.pathname;
				if(ourl_params.title) ourl_params.ptitle = ourl_params.title;
          		if(ourl_params.url) ourl_params.phtml5url = ourl_params.url;
          		delete ourl_params.title;
          		delete ourl_params.url;
			}
			if (okctrl) {
                if(COMMON.getSourec().isFromApp && COMMON.getSourec().isIos){
                	window.location.href = encodeURIComponent('apphref://'+ okctrl.ios +'?zresource=n'+ this._mob_toquery(ourl_params));
                }else if(COMMON.getSourec().isFromApp && COMMON.getSourec().isAndroid){
                    window.control.pushpage( 'apphref://'+ okctrl.android +'?zresource=n'+ this._mob_toquery(ourl_params));
                }else{
                	// ctrl.$router.push({path: href});
                	window.location.href = href;
	            }
	            return;
			}

			if(href.indexOf('http') != -1){
				window.location.href=href;
				return;
			}
		}
	},
	WebHrefRrouter:function(href){
		window.location.href = href;
		// ctrl.$router.push({path:href,param:{a:1}});
	}
}


export default HrefRouter




// WEBPACK FOOTER //
// ./src/global/js/mob_router.js